module.exports = { "default": require("core-js/library/fn/set-immediate"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/set-immediate.js
// module id = 1866
// module chunks = 14